// @ts-strict-ignore
import {Component, inject, input} from "@angular/core";
import {Gender, Participant, ParticipantType} from "@models";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";
import {EnumLabel} from "../../shared-pipes/enum-label.pipe";

/**
 * @deprecated use @common/components/user-details instead
 */
@Component({
	selector: "sim-old-participant-details",
	templateUrl: "./old-participant-details.component.html",
	styleUrl: "./old-participant-details.component.scss",
	standalone: false,
})
export class OldParticipantDetailsComponent {
	// Signals
	public participant = input.required<Participant>();
	public showNameOnly = input<boolean>(false);
	public compact = input<boolean>(false);

	// Readonly
	protected readonly Gender = Gender;
	protected readonly T = Translations;
	protected readonly ParticipantType = ParticipantType;

	// Injections
	public translate = inject(TranslateService);
	protected readonly EnumLabel = EnumLabel;
}
